export const scrollToChatBottom = () => {
  const chatbot = document.getElementById('chatBot');

  chatbot.scrollTo({
    top: chatbot.scrollHeight,
    behavior: 'smooth',
  });
};
